<div
  class="tier-list-container"
  [class.in-drawer]="isInDrawer"
  *transloco="let t; prefix: 'components.wager-options'"
>
  @if (themeService.wagerDrawerConfig().hasBalance) {
    <div class="available-balance">
      <div [ngStyle]="bodyStyle | theme">
        {{ t("available-balance") }} {{ operatorService.formattedBalance()?.text }}
      </div>
    </div>
  } @else {
    <div class="no-balance-padding"></div>
  }

  <ng-template #practiceCard>
    <app-practice-card
      [title]="t('for-fun')"
      [prize]="t('practice')"
      [buttonLabel]="t('free-to-play')"
      (clickEvent)="onPracticeClick()"
    />
  </ng-template>

  <div class="prize-tier-list">
    <div class="grid-container">
      @if (currentTournamentData(); as tournamentData) {
        @if (tournamentData.status !== "FINISHED") {
          <app-tournament-info-card
            class="tournament-card"
            [currentTournamentData]="tournamentData"
            [currentTime]="tick()"
            (clickEvent)="onTournamentPlayClick($event)"
          />
          <div [ngStyle]="titleStyle | theme" class="head-to-head-title">
            {{ t("head-to-head") }}
          </div>
        }
      }
      @if (isPracticeFirst() && !hidePractice()) {
        <ng-container *ngTemplateOutlet="practiceCard" />
      }
      @for (tier of allTiers(); track tier.tierId) {
        <app-wager-card
          [tier]="tier"
          [allTiers]="allTiers()"
          [title]="t('title')"
          (clickEvent)="onWagerClick($event)"
          (celebrationCompleteEvent)="onUnlockCelebrationComplete()"
          [unlockCelebrationActive]="unlockCelebrationActive"
          [waitingOpponentsStandard]="waitingOpponentsStandard"
          [userBalance]="operatorService.balance()"
        />
      }
      @if (!isPracticeFirst() && !hidePractice()) {
        <ng-container *ngTemplateOutlet="practiceCard" />
      }
      @if (canShowLocal) {
        <app-practice-card
          [title]="t('for-testing')"
          [prize]="t('local')"
          [buttonLabel]="t('free-to-play')"
          (clickEvent)="onLocalClick()"
        />
      }
    </div>
    @if (themeService.hasWaitingOpponents()) {
      <div class="player-waiting-opponent">
        <app-icon
          icon="player-waiting"
          colorCss="--panel-wager-tier-list-player-waiting-fill"
          sizeCss="--icon-medium"
        />
        <div [ngStyle]="playerWaitingStyle | theme">
          {{ t("opponent-is-ready") }}
        </div>
      </div>
    }
  </div>
</div>
